// extracted by mini-css-extract-plugin
export default {"control":"Control_control__Miw2f","button":"Control_button__lbZLu"};